import React, { Component } from "react";
import AttributeMessage from "./AttributeMessage";
import RuleHandler from "./RuleHandler";
import DropDownAttribute from "./DifferentAttributes/DropDown";
import TextFieldAttribute from "./DifferentAttributes/TextField";
import TextAreaAttribute from "./DifferentAttributes/TextArea";
import NumberTextFieldAttribute from "./DifferentAttributes/NumberField";
import DatePickerAttribute from "./DifferentAttributes/DatePicker";
import CheckBoxAttribute from "./DifferentAttributes/CheckBox";
import FileUpload from "./DifferentAttributes/FileUpload";
import MultiChoice from "./DifferentAttributes/MultiChoiceDropDown";
import RadioButtonGroupAttribute from "./DifferentAttributes/RadioButtonGroup";
import SliderAttribute from "./DifferentAttributes/Slider";
import SliderGroupAttribute from "./DifferentAttributes/SliderGroup";
import AttributeCollection from "./DifferentAttributes/AttributeCollection";
import GeoPointPicker from "./DifferentAttributes/GeoPointPicker";
import Tooltip from "@mui/material/Tooltip";
import DataStore from "./../../stores/DataStore";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { reaction } from "mobx";

/**
 *
 * @typedef {object} Props
 * @prop {string} className
 * @prop {number} numberProp
 * @extends {Component<Props>}
 * Modul, welches die Anzeige für das spezielle Attribut erstellt.*/
class AttributeModul extends Component {
  static propTypes = {
    attribute: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      tooltip: PropTypes.string,
      type: PropTypes.oneOf([
        "dropDown",
        "textfield",
        "checkBox",
        "datePicker",
        "textArea",
        "multiChoice",
        "radioButtonGroup",
        "fileUpload",
        "numberTextField",
        "slider",
        "sliderGroup",
        "attributeCollection",
        "custom",
      ]),
      rules: PropTypes.array,
      requestKey: PropTypes.string,
      attributeOption: PropTypes.object,
    }),
  };

  constructor(params) {
    super(params);
    this.DataStore = DataStore;
    // this.configSource = JSON.parse(JSON.stringify(this.props));
    // this.targetConfig = JSON.parse(JSON.stringify(this.configSource))
    this.state = {
      readOnlySet: undefined,
      requiredSet: undefined,
      visibleSet: undefined,
      loaded: false,
      // forbiddenSet: false,
      value: undefined,
      currentConfig: undefined,
    };
    this.ruleMessageFields = [];
    this.onChangeFuncs = [];
  }

  /**
   * Sobald das Modul erstellt ist, wird das Modul in den AttributeModulsHandler geschrieben
   * Rules werden initial überprüft
   * State wird gesetzt
   * @function AttributeModul.componentDidMount
   */
  componentDidMount() {
    if (this.id) {
      if (typeof DataStore.attributeValues[this.id] == typeof undefined) {
        DataStore.addAttribute(this.props.attribute);
      }
      DataStore.attributeValues[this.id].setModul(this);
    }
    this.ruleHandler.forEach((ruleH) => {
      ruleH.checkRule();
    });
    this.setState({ loaded: true });
    reaction(
      () => DataStore.attributeValues[this.id].value,
      () =>
        this.ruleHandler.forEach((ruleH) => {
          ruleH.checkRule();
        })
    );
    if (this.requestKey !== undefined) {
      reaction(
        () => DataStore.requestStore.requests[this.requestKey].state,
        () =>
          this.ruleHandler.forEach((ruleH) => {
            ruleH.checkRule();
          })
      );
    }
    // this.setUpReactionsFromExternStore();
  }

  // /**
  //  * @function AttributeModul.addOnChange
  //  * @param {Function} onChange Funktion, die bei Änderung des AttributWertes aufgerufen werden soll
  //  */
  // addOnChange(onChange) {
  //   this.onChangeFuncs.push(onChange);
  // }

  /**
   * Refreshed die Regeln eines Attributes bei Wertänderung
   * @function AttributeModul.onValueChanged
   * @param {*} newVal neuer Wert des gespeicherten Attributes
   */
  onValueChanged(newVal) {
    DataStore.attributeValues[this.id].setValue(newVal);
  }

  /**
   * @function AttributeModul.getAttribute
   * @return {Component} Gibt das Passende Spezielle Attribut wieder
   */
  getAttribute() {
    const { attribute } = this.props;
    const attributeState = DataStore.attributeValues[this.id];
    attribute.controlState = {
      readOnly: attributeState.readOnly,
      visible: attributeState.visible,
      required: attributeState.required,
      value: attributeState.value,
      updateOptions: attributeState.updateOptions,
    };
    attribute.attributeOption =
      this.attributeOption || attribute.attributeOption;
    if (attributeState.updateOptions) {
      Object.keys(attributeState.updateOptions).forEach(
        (key) =>
          (attribute.attributeOption[key] = attributeState.updateOptions[key])
      );
    }
    attribute.onChange = this.onValueChanged.bind(this);
    attribute.attributeModul = this;
    const { type, CustomComponent } = attribute;
    attribute.name = this.name;

    DataStore.getHandler().messageHandler.logDebugFormatted(
      "AttributeModul",
      "getAttribute",
      "",
      this.props,
      this.state,
      type
    );
    let AttrComp = TextFieldAttribute;
    switch (type) {
      case "dropDown": {
        AttrComp = DropDownAttribute;
        break;
      }
      case "textfield": {
        AttrComp = TextFieldAttribute;
        break;
      }
      case "checkBox": {
        AttrComp = CheckBoxAttribute;
        break;
      }
      case "datePicker": {
        AttrComp = DatePickerAttribute;
        break;
      }
      case "textArea": {
        AttrComp = TextAreaAttribute;
        break;
      }
      case "multiChoice": {
        AttrComp = MultiChoice;
        break;
      }
      case "radioButtonGroup": {
        AttrComp = RadioButtonGroupAttribute;
        break;
      }
      case "fileUpload": {
        AttrComp = FileUpload;
        break;
      }
      case "numberTextField": {
        AttrComp = NumberTextFieldAttribute;
        break;
      }
      case "slider": {
        AttrComp = SliderAttribute;
        break;
      }
      case "sliderGroup": {
        AttrComp = SliderGroupAttribute;
        break;
      }
      case "attributeCollection": {
        AttrComp = AttributeCollection;
        break;
      }
      case "geometry": {
        AttrComp = GeoPointPicker;
        break;
      }
      case "custom": {
        const holdedAttribute = (
          <CustomComponent
            attribute={attribute}
            key={attribute.id}
            AtrModClass={AttributeModul} //Da sonst mit der AttributeCollection eine zyklische Abhängigkeit besteht
            parent={this}
            DataStore={this.DataStore}
          />
        );
        DataStore.getHandler().messageHandler.logDebugFormatted(
          "AttibuteModul",
          "getAttribute => CUSTOM",
          "",
          this.props,
          this.state,
          holdedAttribute
        );
        return holdedAttribute;
      }
      default: {
      }
    }
    const holdedAttribute = (
      <AttrComp
        attribute={attribute}
        key={attribute.id}
        AtrModClass={AttributeModul}
        parent={this}
      />
    );

    DataStore.getHandler().messageHandler.logDebugFormatted(
      "AttibuteModul",
      "getAttribute",
      "",
      this.props,
      this.state,
      holdedAttribute
    );
    return holdedAttribute;
  }

  /**
   * setzt Regeln und die dazugehörigen Nachrichten.
   * Eventuell dazugehörend: Standard "Required" Rule (wenn Attribut von vorn herein required)
   * @return {Component} React Componenten für Nachrichtenanzeige für das Attribut
   */
  getRuleMessageFields(rules) {
    this.ruleMessageFields = [];
    let ruleHandlerReady = true;
    if (!this.ruleHandler) {
      ruleHandlerReady = false;
      this.ruleHandler = [];
    }
    for (let i = 0; i < rules.length; i++) {
      // rules[i].attributeModul = this;
      rules[i].attribute = this.id;
      if (!ruleHandlerReady || !this.ruleHandler[i]) {
        const ruleHandler = new RuleHandler(rules[i]);
        this.ruleHandler.push(ruleHandler);
      }
      const ruleMessage = (
        <AttributeMessage
          ifViolatedType={rules[i].ifViolatedType}
          ifViolatedText={rules[i].ifViolatedText}
          ifViolatedTextStore={rules[i].ifViolatedTextStore}
          ifViolatedTextKey={rules[i].ifViolatedTextKey}
          ruleHandler={this.ruleHandler[i]}
          key={`${this.id}ruleMessage${i}`}
        />
      ); // TODO optionen übergeben
      this.ruleMessageFields.push(ruleMessage);
    }
    DataStore.getHandler().messageHandler.logDebugFormatted(
      "AttributeModul",
      "getRules",
      "",
      this.props,
      this.state,
      [this.ruleHandler, this.ruleMessageFields]
    );
    return this.ruleMessageFields;
  }

  /**
   * @function AttributeModul.hasError
   * @return {boolean} true, wenn es eine Regel gibt, dessen Typ "error" ist, welche verletzt ist
   */
  hasError() {
    let err = false;
    const errText = [];
    this.ruleHandler.forEach(function (ruleH) {
      if (ruleH.hasError()) {
        err = true;
        errText.push(ruleH.ifViolatedText);
      }
    });
    DataStore.getHandler().messageHandler.logDebugFormatted(
      "AttributeModul",
      "hasError",
      "",
      this.props,
      this.state,
      [err, errText]
    );
    return { error: err, errText };
  }

  /**
   * returns key/id of Attribute
   */
  getKey() {
    return this.id;
  }

  /**
   * returns value of Attribute (kann alles mögliche sein..)
   */
  getValue() {
    return DataStore.attributeValues[this.id].value;
  }

  /**
   * gibt ein paar aus key und value zurück in der Form:
   * {
   *    key: ".."
   *    value: 12
   * }
   */
  getKeyValuePair() {
    return {
      key: this.getKey(),
      value: this.getValue(),
    };
  }

  getValueString() {
    return this.holdedAttribute.getValueString();
  }

  getSummaryDisplay() {
    const valDisplay =
      DataStore.attributeValues[this.id].value === null ||
        DataStore.attributeValues[this.id].value === undefined ? (
        <div></div>
      ) : (
        this.holdedAttribute.getSummaryDisplay()
      );
    return (
      <div
        key={this.id + "summaryDisplay"}
        style={{
          display: "flex",
          alignItems: "baseline",
          marginTop: "5px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "50%",
          }}
        >
          {`${this.id}: `}
        </div>
        <div
          style={{
            display: "flex",
            width: "50%",
          }}
        >
          {valDisplay}
        </div>
      </div>
    );
  }

  /**
   * @function AttributeModul.setValue Um den Wert des Attributes Nachträglch zu setzen (bspw durch nach Serverabfrage)
   * @param {*} value gesetzter Wert
   */
  setValue(value) {
    const { attribute } = this.props;
    attribute.value = value;
  }

  /**
   * Modul, welches die Anzeige für das spezielle Attribut erstellt.
   * @render
   * @param {object} this.state
   * @param {object} this.props
   * @param {string} this.props.id - ID des Attributes
   * @param {string} this.props.name - Anzeigename des Attributes
   * @param {string} this.props.description - Beschreibung des Attributs
   * @param {string} this.props.tooltip - Tooltip, welcher bei Hover über die Attributanzeige angezeigt werden soll
   * @param {string} this.props.type - Typ des Attributs (z.b. "DropDown")
   * @param {boolean} this.props.readOnly - Gibt an, ob das Attribut nur lesend betrachtet werden kann
   * @param {boolean} this.props.required - Gibt an, ob das Attribut zwingend gefüllt werden muss.
   * @param {Array} this.props.rules - Array aus Regeln für das Attribut (mit den dazugehörigen Nachrichten)
   * @param {object} this.props.attributeOption - Optionne für das spezielle Attribut (z.b. für das DropDown).
   */
  render() {
    const { loaded, currentConfig } = this.state;
    const {
      attribute: {
        id = "",
        name = id,
        description = "",
        placeholder = "",
        tooltip = "",
        type = "",
        rules = [],
        requestKey,
        attributeOption = {},
      },
      messageHandler,
      requestHandler,
    } = currentConfig || this.props;
    const attributeState = DataStore.attributeValues[id];
    // this.virtuell = atributeState.virtuell;
    this.id = id;
    this.name = this.name || name;
    this.description = this.description || description;
    this.placeholder = this.placeholder || placeholder;
    this.tooltip = this.tooltip || tooltip;
    this.type = type;
    this.rules = rules;
    this.attributeOption = attributeOption; //this.attributeOption || Object.assign({}, attributeOption);
    this.messageHandler = messageHandler;
    this.requestHandler = requestHandler;
    let requiredRule = [];
    if (attributeState.required) {
      requiredRule.push({
        condition: {
          atom: {
            filled: true,
          },
        },
        ifViolatedType: "error",
        ifViolatedText: "Required!",
      });
    }
    let requestRules = [];
    this.requestKey = requestKey;
    if (requestKey) {
      this.requestKey = requestKey;
      requestRules.push({
        condition: {
          not: {
            atom: {
              requestLoadingState: "loading",
            },
          },
        },
        ifViolatedType: "loading",
        ifViolatedText: "loading",
      });
      requestRules.push({
        condition: {
          not: {
            atom: {
              requestLoadingState: 2,
            },
          },
        },
        ifViolatedType: "error",
        ifViolatedTextKey: "message",
        ifViolatedTextStore: DataStore.requestStore.requests[requestKey],
      });
    }
    DataStore.getHandler().messageHandler.logDebugFormatted(
      "AttributeModul",
      "render",
      "",
      this.props,
      this.state
    );
    if (loaded) {
      this.ruleHandler.forEach((ruleH) => {
        ruleH.checkRule();
      });
      // this.setComputed();
    }
    const atr = this.getAttribute();
    const ruleMassegFields = this.getRuleMessageFields(
      rules.concat(requiredRule).concat(requestRules)
    );
    return (
      <Tooltip title={this.tooltip}>
        <div
          style={{
            display: attributeState.visible ? "flex" : "none",
            marginTop: this.type === "attributeCollection" ? "15px" : "10px",
            // display: "flex",
            margiTop: "10px",
            flexFirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          key={id}
        >
          {atr}
          <span
            style={{
              alignSelf: "flex-end",
              display: "block",
              position: "relative",
              width: "25px",
              flexGrow: 0,
            }}
          >
            {ruleMassegFields}
          </span>
        </div>
      </Tooltip>
    );
  }
}
export default observer(AttributeModul);
